import type { GridProps } from '@chakra-ui/react'
import { forwardRef, Grid } from '@chakra-ui/react'

export interface QuestionMarkIconProps extends GridProps {}

export const QuestionMarkIcon = forwardRef(
  ({ children, sx, ...rest }: QuestionMarkIconProps, ref) => {
    return (
      <Grid
        ref={ref}
        sx={{
          w: 5,
          h: 5,
          placeContent: 'center',
          placeItems: 'center',
          bgColor: 'primary.500',
          borderRadius: 'full',
          color: 'white',
          fontSize: 'xs',
          fontWeight: 'medium',
          ...sx,
        }}
        {...rest}
      >
        {children || '?'}
      </Grid>
    )
  },
)
